import React from 'react';
import css from '../../../../styles/modules/PaymentSummary/paymentdetails.module.css';
import { NumericFormat } from 'react-number-format';
import returnStatusCSS from './lib/returnStatusCSS';
import statusDate from './lib/statusDate';
import statusBar from './lib/statusBar';

export default function ProgressAndDollar({
  status,
  isLoading,
  amount,
  updatedOn,
  completedOn,
}) {
  return (
    <div className={css.progressBarWrapper}>
      <div
        className={
          status?.toLowerCase() === 'error' ? css.amountRed : css.amount
        }
      >
        <NumericFormat
          displayType="text"
          prefix="$"
          value={Number(amount).toFixed(2)}
          decimalScale={2}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
        />
      </div>

      {statusBar(status, css)}
      <div className={css.progressBarBottomContainer}>
        <h1 className={returnStatusCSS(status, css)}>
          {status ? status.charAt(0).toUpperCase() + status.slice(1) : ''}
        </h1>
        {statusDate(status, completedOn, css, updatedOn)}
      </div>
    </div>
  );
}
